import {useEffect, useState} from "react"
import {Button} from "react-bootstrap"
import {Dropdown} from "primereact/dropdown"
import {Calendar} from "primereact/calendar"
import {Skeleton} from "primereact/skeleton"
import {default as cx} from "classnames"

import {getJSDate, normalizeDate} from "../../../utilities/general.jsx"

const PickOrientee = ({
    orientationId,
    orientationWeekId,
    orientationList,
    setOrientationId,
    orienteeName,
    orientationWeeks,
    shiftDate,
    setShiftDate,
    startReport,
    isLoading,
    isGuest,
}) => {
    const [empty, setEmpty] = useState(false)
    const [startDate, setStartDate] = useState(null)
    const today = normalizeDate(new Date())
    const selectedOrientationWeek = orientationWeeks?.find((week) => String(week.id) === String(orientationWeekId))
    const weekStartDate = getJSDate(selectedOrientationWeek?.start_date)
    const weekEndDate = getJSDate(selectedOrientationWeek?.end_date)
    const hasWeekDateRange = Boolean(weekStartDate && weekEndDate)

    useEffect(() => {
        const weekStartDate = getJSDate(selectedOrientationWeek?.start_date)
        const weekEndDate = getJSDate(selectedOrientationWeek?.end_date)
        if (!weekStartDate || !weekEndDate) return

        const selectedDate = shiftDate ?? normalizeDate(new Date())
        if (selectedDate < weekStartDate) {
            setShiftDate(weekStartDate)
        } else if (selectedDate > weekEndDate) {
            setShiftDate(weekEndDate)
        }
    }, [shiftDate, orientationId, selectedOrientationWeek])

    const submit = () => {
        if (orientationId) {
            setEmpty(false)
            startReport()
        } else {
            setEmpty(true)
        }
    }

    function selectOrientation(orientationId) {
        const orientation = orientationList.find((o) => o.id === orientationId)
        setOrientationId(orientation ? orientation.id : "")
        setStartDate(getJSDate(orientation?.start_date))
    }

    return (
        <div className="w-100">
            <div>
                <div className="d-flex flex-row">
                    <h1 className="d-flex flex-column text-dark fw-bold fs-2">
                        Please complete this report at least weekly to let us know how your orientee is progressing.
                    </h1>
                </div>
                <div className="d-flex flex-column text-dark fs-5 mb-4">
                    This report will be sent to you weekly until your assigned orientee has completed orientation. If
                    you are back-documenting for multiple weeks/shifts please complete a separate OSR for each
                    week/shift.
                </div>
            </div>
            <div className="w-100 my-5">
                <div className="flex-column">
                    <label 
                        className={cx(
                            "text-dark fw-bold fs-2",
                            isGuest ? "required" : "not-required"
                        )}                    
                    >Orientee Name: </label>
                    {isLoading && (
                        <Skeleton className="w-100 h-40px" />
                    )}

                    {!isLoading && !isGuest && (
                        <div className="text-dark fs-5 mb-4">{orienteeName}</div>
                    )}

                    {!isLoading && isGuest && (
                        <Dropdown
                                className={cx("w-100 p-dropdown-tall", {"border border-1 border-danger": empty})}
                                options={orientationList.map((orientation) => ({
                                    label: orientation.name,
                                    value: orientation.id,
                                }))}
                                filter={true}
                                value={orientationId}
                                placeholder="Select Orientee"
                                disabled={orientationId}
                                onChange={(option) => selectOrientation(option.value || "")}
                            />
                    )}
                    {empty && <span className="text-danger mt-n5">Orientee is required</span>}
                </div>
            </div>
            <div>
                <label className="text-dark fw-bold fs-3 mt-5 required">OSR Shift Date</label>
                <div className="text-dark fs-5 mb-4">
                    If back-documenting an OSR, please indicate the date of the last precepted shift that this OSR is
                    reflective of.
                </div>
                <div className="d-flex gap-4">
                    <Calendar
                        showIcon
                        className="w-100 p-dropdown-tall"
                        placeholder="Shift Date"
                        minDate={isGuest ? startDate : weekStartDate ?? startDate}
                        value={shiftDate}
                        maxDate={weekEndDate && weekEndDate < today ? weekEndDate : today}
                        disabled={Boolean(orientationWeekId) && (isLoading || !hasWeekDateRange)}
                        onChange={(e) => setShiftDate(normalizeDate(e.value))}
                    />
                </div>
            </div>
            <div className="d-flex mt-8 gap-6">
                <Button className="btn btn-primary btn-flex" onClick={submit}>
                    Start Assessment
                </Button>
            </div>
        </div>
    )
}

export default PickOrientee
